const appbarStyle = {
	background: "#00000054 0% 0% no-repeat padding-box",
	height: "100px",
	display: "flex",
	alignItems: "center",
};

export default appbarStyle;
